import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "main-div" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column is-one-third-desktop is-offset-one-third-desktop" }
const _hoisted_5 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "is-flex is-flex-direction-column is-justify-content-center"
}
const _hoisted_7 = {
  key: 1,
  class: "is-flex is-flex-direction-column is-align-content-center"
}
const _hoisted_8 = {
  key: 2,
  class: "mt-5"
}
const _hoisted_9 = {
  key: 3,
  class: "mt-5 has-text-centered"
}

import {onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import {useStore} from "vuex";



const __default__ = {
  name: "RequestSent",
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const store = useStore()
const paymentHash = ref()
const validating = ref(true)
const hasError = ref(false)

onMounted(async () => {
  paymentHash.value = route.params.payment_hash

  /* validate payment */
  try {
    const validated = await store.dispatch('confirmPayment', paymentHash.value)

    /* turn off validation state */
    if (validated) {
      validating.value = false
    }/* turn off validation state */
    if (validated) {
      validating.value = false
    }
  } catch (e) {
    hasError.value = true
  }


})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: "https://i.imgur.com/uA3fRLZ.png",
                class: "image",
                alt: "logo"
              })
            ], -1)),
            (validating.value && !hasError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[0] || (_cache[0] = [
                  _createElementVNode("div", null, "Wait a moment please...", -1),
                  _createElementVNode("progress", { class: "progress is-primary" }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (hasError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[1] || (_cache[1] = [
                  _createStaticVNode("<div class=\"mt-5 has-text-centered\" data-v-a787168e><span class=\"fa fa-times has-text-danger fa-6x\" data-v-a787168e></span></div><p class=\"is-size-5 has-text-centered\" data-v-a787168e> There was a problema validating your payment. </p><p class=\"has-text-grey has-text-centered\" data-v-a787168e> Contact our support at <a href=\"mailto:support@vetexpertise.com\" data-v-a787168e>support@vetexpertise.com</a></p>", 3)
                ])))
              : _createCommentVNode("", true),
            (!validating.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[2] || (_cache[2] = [
                  _createElementVNode("span", { class: "fa fa-check has-text-success fa-6x" }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (!validating.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[3] || (_cache[3] = _createElementVNode("p", { class: "is-size-3" }, " Thank you! ", -1)),
                  _cache[4] || (_cache[4] = _createElementVNode("p", { class: "is-size-5" }, " Your request has been sent to our specialist. ", -1)),
                  _cache[5] || (_cache[5] = _createElementVNode("p", { class: "has-text-grey" }, " We will confirm it as soon as possible and send you an email with instructions. ", -1)),
                  _createVNode(_component_router_link, { to: "/meeting" })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})